import React from "react";
import styled from "styled-components";
import { ProductConsumer } from "../context/context";
import { SegmentedControl } from 'segmented-control-react';




export default function PizzaSizeChoice() {
  
	return (
		<ProductConsumer>
			{(value) => {
                const{segments,selected,handleChangeSize}=value;
               
				return (
					<PizzaSizeChoiceWrapper>
					  <SegmentedControl
            segments={segments}
            selected={selected} 
            variant="base"
            onChangeSegment={handleChangeSize}           
        />  
					</PizzaSizeChoiceWrapper>
				);
			}}
		</ProductConsumer>
	);
}

const PizzaSizeChoiceWrapper = styled.div`

`;
